(() => {
  function headerOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    return parseFloat(raw) || 60;
  }

  function initStack(root) {
    if (root.dataset.stackInit === 'true') return;
    root.dataset.stackInit = 'true';

    const cards = Array.from(root.querySelectorAll('[data-stack-card]'));
    const rows = Array.from(root.querySelectorAll('[data-rail-row]'));
    if (!cards.length) return;

    const controller = new AbortController();
    const { signal } = controller;
    root.__stackAbort = controller;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let pins = [];
    const equalizeCardHeights = () => {
      for (const card of cards) {
        card.style.minHeight = '';
      }

      if (!window.matchMedia('(min-width: 750px)').matches) return;

      let maxHeight = 0;
      for (const card of cards) {
        maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
      }

      const minHeight = `${Math.ceil(maxHeight)}px`;
      for (const card of cards) {
        card.style.minHeight = minHeight;
      }
    };
    const measurePins = () => {
      equalizeCardHeights();
      pins = cards.map((card) => {
        const top = getComputedStyle(card).top;
        return top === 'auto' ? NaN : parseFloat(top);
      });
    };
    measurePins();

    const resetZIndex = () => {
      for (const [i, card] of cards.entries()) {
        card.style.zIndex = String(i + 1);
      }
    };
    resetZIndex();

    let revealed = false;
    const sync = () => {
      let active = 0;
      for (const [i, card] of cards.entries()) {
        const pin = Number.isFinite(pins[i]) ? pins[i] : 0;
        if (card.getBoundingClientRect().top <= pin + 4) active = i;
      }
      for (const [i, row] of rows.entries()) {
        const isActive = i === active;
        row.classList.toggle('is-active', isActive);
        row.setAttribute('aria-current', isActive ? 'true' : 'false');
      }
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        sync();
        ticking = false;
      });
    };

    const onResize = () => {
      measurePins();
      onScroll();
    };

    window.addEventListener('scroll', onScroll, { passive: true, signal });
    window.addEventListener('resize', onResize, { signal });
    window.addEventListener('load', onResize, { signal });
    const waitForFonts = async () => {
      if (!document.fonts?.ready) return;
      await document.fonts.ready;
      if (signal.aborted) return;
      onResize();
    };
    waitForFonts();
    sync();

    const clearReveal = () => {
      if (!revealed) return;
      revealed = false;
      resetZIndex();
    };
    window.addEventListener('wheel', clearReveal, { passive: true, signal });
    window.addEventListener('touchstart', clearReveal, { passive: true, signal });

    const revealCard = (card) => {
      resetZIndex();
      card.style.zIndex = '50';
      revealed = true;
      const computedTop = getComputedStyle(card).top;
      const pin = computedTop === 'auto' ? headerOffset() : (parseFloat(computedTop) || headerOffset());
      const rect = card.getBoundingClientRect();
      const delta = rect.top - pin;
      window.scrollBy({
        top: delta,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    for (const card of cards) {
      card.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        revealCard(card);
      }, { signal });
    }

    for (const [i, row] of rows.entries()) {
      row.addEventListener('click', () => {
        const card = cards[i];
        if (card) revealCard(card);
      }, { signal });
    }
  }

  function init() {
    for (const root of document.querySelectorAll('[data-homepage-v2-stack]')) {
      initStack(root);
    }
  }

  function unload(event) {
    for (const root of event.target.querySelectorAll('[data-homepage-v2-stack]')) {
      root.__stackAbort?.abort();
      delete root.__stackAbort;
      delete root.dataset.stackInit;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', unload);
})();
